import { WorkflowTemplateStatus } from '../Types'

const marketing: WorkflowTemplateStatus = {
  configuration: {
    '6cb52d2b-16e3-44ff-a29f-7c306b3a0d3a': {
      exit: [],
      entry: [],
    },
    '82757aeb-8bbc-44b1-ad01-ecde16c86bf5': {
      exit: [
        {
          type: 'reviews.close',
          config: {},
        },
      ],
      entry: [
        {
          type: 'reviews.create',
          config: {},
        },
      ],
    },
    '67f9fb0c-a55a-4418-aeec-41081886a214': {
      exit: [],
      entry: [],
    },
    'a1ac7313-b657-4bb6-adef-0a67b256513d': {
      exit: [
        {
          type: 'reviews.close',
          config: {},
        },
      ],
      entry: [
        {
          type: 'approvals.create',
          config: {},
        },
      ],
    },
    '86b47bdf-07d0-4507-a601-a1c7484a4d08': {
      exit: [],
      entry: [],
    },
    '4aaf9449-46e4-4fa3-8d83-5075e4afc54c': {
      exit: [],
      entry: [],
    },
    '74e1791a-e87b-4c7a-8451-a2e6dcc9ad8d': {
      exit: [],
      entry: [],
    },
    '4bed98b5-0c3d-4f8b-930c-335d4c3b5480': {
      exit: [],
      entry: [],
    },
  },
  property_values: [
    {
      uuid: '6cb52d2b-16e3-44ff-a29f-7c306b3a0d3a',
      value: 'Draft',
      meta: {
        color: '#E5ECF3',
      },
      position: 0,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: '82757aeb-8bbc-44b1-ad01-ecde16c86bf5',
      value: 'Team Review',
      meta: {
        color: '#FFD6B8',
      },
      position: 1,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: '67f9fb0c-a55a-4418-aeec-41081886a214',
      value: 'Team Reviewed',
      meta: {
        color: '#FA7514',
      },
      position: 2,
      connected_to_uuid: '82757aeb-8bbc-44b1-ad01-ecde16c86bf5',
      connected_to_id: null,
    },
    {
      uuid: 'a1ac7313-b657-4bb6-adef-0a67b256513d',
      value: 'Leadership Approval',
      meta: {
        color: '#FFD6F9',
      },
      position: 3,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: '4bed98b5-0c3d-4f8b-930c-335d4c3b5480',
      value: 'Leadership Approved',
      meta: {
        color: '#E43CD5',
      },
      position: 4,
      connected_to_uuid: 'a1ac7313-b657-4bb6-adef-0a67b256513d',
      connected_to_id: null,
    },
    {
      uuid: '86b47bdf-07d0-4507-a601-a1c7484a4d08',
      value: 'Ready',
      meta: {
        color: '#D0F8F3',
      },
      position: 5,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: '74e1791a-e87b-4c7a-8451-a2e6dcc9ad8d',
      value: 'Published',
      meta: {
        color: '#00BF9D',
      },
      position: 5,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: '4aaf9449-46e4-4fa3-8d83-5075e4afc54c',
      value: 'Deprecated',
      meta: {
        color: '#FFCBCB',
      },
      position: 6,
      connected_to_uuid: null,
      connected_to_id: null,
    },
  ],
}

export default marketing
